const ART_DIRECTION = `ART DIRECTION:
Match the current Progress Lands enemy artwork: original cel-shaded post-apocalyptic comic art.
Use a strong readable silhouette, thick charcoal outlines, angular shapes, hard-edged upper-left highlights, controlled lower-right shadows, and a limited dusty scavenger palette.
The object should look worn, repaired, improvised, or naturally weathered where appropriate.
Avoid glossy fantasy, clean futuristic materials, photorealism, painterly rendering, soft gradients, text, logos, frames, UI, and presentation sheets.`;

const ALPHA_REQUIREMENTS = `NATIVE TRANSPARENCY — FILE EXPORT, NOT ART:
- return an 8-bit RGBA PNG; an RGB PNG is invalid
- transparency is file data: every pixel outside the subject must have alpha 0
- do not depict or paint a background or a transparency-preview pattern
- all four corner pixels must have alpha 0
- keep the subject interior fully opaque (alpha 255)
- partial alpha is permitted only in a narrow 1–2 pixel antialias fringe along the outer silhouette
- include no visible backdrop, glow, matte, shadow rectangle, halo, or leftover background color`;

export function buildItemImagePrompt(
  item = {},
  itemTypeName = '',
  { mapRepresentation = false } = {},
) {
  const name = item.name?.trim() || '[ENTER ITEM NAME]';
  const type = itemTypeName?.trim() || '[ENTER ITEM TYPE]';
  const description = item.visualDescription?.trim()
    || '[ENTER VISUAL DESCRIPTION]';
  const functionalRead = type.toLowerCase() === 'weapon'
    ? `WEAPON READABILITY — BINDING:
- the silhouette must immediately read as a dangerous improvised weapon, not an untouched prop or toy
- make the described striking, cutting, or piercing feature dominant without inventing parts that contradict the visual description`
    : '';
  const role = mapRepresentation
    ? 'Optional gatherable resource or crafting-material map representation'
    : 'Inventory, loot, crafting, and item-detail artwork';
  const composition = mapRepresentation
    ? `MAP REPRESENTATION:
- show a strict top-down or lightly elevated top-down world-map view
- depict one believable gatherable node, pile, cluster, or patch rather than a floating inventory icon
- for materials such as driftwood, show several naturally arranged pieces that read as a resource pile
- center the ground contact point and keep the silhouette readable at approximately 48 × 48 gameplay pixels
- fill approximately 70–80% of the canvas with transparent padding and do not crop the subject
- do not bake terrain, ground color, a base plate, or an environmental scene into the image`
    : `ITEM REPRESENTATION:
- show one isolated item or one compact representative bundle
- use a readable three-quarter view consistent with current enemy and entity artwork
- fill approximately 75–85% of the canvas with transparent padding and do not crop the subject
- keep the silhouette readable at 64 × 64 and 128 × 128 pixels
- no scene, character, hands, pedestal, ground plane, or additional decorative objects`;

  return `Create one production-ready item artwork asset for the game “Progress Lands”.

ITEM NAME:
${name}

ITEM TYPE:
${type}

VISUAL DESCRIPTION:
${description}

ASSET ROLE:
${role}

${ALPHA_REQUIREMENTS}

${functionalRead ? `${functionalRead}\n\n` : ''}${ART_DIRECTION}

${composition}

OUTPUT:
- square 1:1 aspect ratio
- 512 × 512 to 2048 × 2048 pixels; prefer 1024 × 1024
- transparent 8-bit RGBA PNG
- clean standalone game asset with no watermark or mockup`;
}
